import { Linkable } from "@/components/blocks/Linkable";
import { useLocalization } from "@/data/Localization";
import { SxProps, Theme } from '@mui/material';
import { Stack, useMediaQuery } from "@mui/system";
import { FC } from "react";
import { ContentRecommendation } from "../../ContentRecommendation";
import { headerPlayButtonSX } from "../styles/container";
import { HeaderPlayButton } from "./HeaderPlayButton";

export const NavBarRightLinks:FC<{sx?:SxProps}> = ({sx}) => {
    const HeaderLabels = useLocalization('Header');
    const RouteLocal = useLocalization('Routes');
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    return(
        <Stack>
            <Linkable id="storeLocatorQuickLink" href={`/${RouteLocal.StoreLocator.route.t()}`} role="link">{HeaderLabels.Actions.Stores.t()}</Linkable>
            <ContentRecommendation id="IT-Header-Klantenservice-Link-eSpot_rv" properties={{emsName:"IT-Header-Klantenservice-Link-eSpot_rv"}} />
            {!isMobile ? <HeaderPlayButton sx={headerPlayButtonSX} /> : null}
        </Stack>
    );
}